<div class="timeline-layout">
    <div class="card timeline-card flujo-registro-card" *ngIf="loadingPasosFlujo || pasosFlujo.length > 0">
        <div class="timeline-header mb-3">
            <div>
                <div class="font-semibold text-xl">Recorrido del flujo</div>
                <small class="text-600">Qué vio el cliente y qué eligió, en orden.</small>
            </div>
        </div>

        <p-skeleton *ngIf="loadingPasosFlujo" height="4rem" styleClass="mb-2"></p-skeleton>

        <p-timeline *ngIf="!loadingPasosFlujo" [value]="pasosFlujo" align="left" styleClass="flujo-registro-timeline">
            <ng-template pTemplate="marker" let-paso>
                <span class="flujo-paso-marker" [ngClass]="{ 'flujo-paso-marker-campana': esPasoDeCampana(paso) }">
                    <i [class]="getNodoTipoIcono(paso)"></i>
                </span>
            </ng-template>
            <ng-template pTemplate="content" let-paso>
                <div class="flujo-paso-content mb-3">
                    <div class="flex align-items-center gap-2 mb-1 flex-wrap">
                        <p-tag
                            [value]="esPasoDeCampana(paso) ? 'Mensaje de campaña' : getNodoTipoLabel(paso)"
                            [severity]="esPasoDeCampana(paso) ? 'info' : 'secondary'">
                        </p-tag>
                        <small class="text-500">{{ paso.fechaOperacion | date: 'dd/MM/yyyy HH:mm' }}</small>
                    </div>
                    <div class="flujo-paso-texto" *ngIf="paso.textoMostrado">{{ paso.textoMostrado }}</div>
                    <div class="flujo-paso-eleccion mt-1" *ngIf="paso.opcionEtiqueta">
                        <i class="pi pi-reply text-600"></i> Eligió: <strong>{{ paso.opcionEtiqueta }}</strong>
                    </div>
                </div>
            </ng-template>
        </p-timeline>
    </div>

    <div class="card timeline-card message-card">
        <div class="timeline-header mb-4">
            <div>
                <div class="font-semibold text-xl">Chat</div>
                <small class="text-600">Leé el intercambio completo antes de responder.</small>
            </div>
            <div class="timeline-counter">{{ messages.length }} mensaje<span *ngIf="messages.length !== 1">s</span></div>
        </div>

        <div *ngIf="events.length > 0" class="conversation-events mb-3 flex flex-wrap gap-2">
            <span *ngFor="let event of events" [pTooltip]="event.summary" tooltipPosition="top">
                <p-tag [value]="getEventTypeLabel(event)" [severity]="getEventTypeSeverity(event)"></p-tag>
            </span>
        </div>

        <div class="message-thread-shell">
            <div *ngIf="messages.length === 0" class="empty-thread text-center text-600 py-6">
                Todavía no hay mensajes cargados para esta conversación.
            </div>

            <div *ngIf="messages.length > 0" class="message-thread">
                <div *ngFor="let message of messages; let index = index" class="message-row" [ngClass]="getMessageRowClasses(message)">
                    <div class="message-bubble" [ngClass]="getMessageBubbleClasses(message)">
                        <div class="bubble-topline mb-1">
                            <div class="bubble-author-group">
                                <div class="bubble-avatar">{{ message.direction_code === outboundCode ? 'A' : 'C' }}</div>
                                <div>
                                    <div class="font-semibold text-sm bubble-actor">{{ getActorLabel(message) }}</div>
                                    <small class="text-500 bubble-meta">{{ message.fecha_operacion | date: 'dd/MM/yyyy HH:mm' }}</small>
                                </div>
                            </div>
                            <small *ngIf="message.direction_code === outboundCode" class="delivery-status" [ngClass]="'delivery-' + getDeliverySeverity(message.delivery_status_code)">
                                {{ getDeliveryLabel(message.delivery_status_code) }}
                            </small>
                        </div>

                        <p-tag *ngIf="showMessageTypeTag(message)" [value]="getMessageTypeLabel(message)" severity="secondary" styleClass="message-type-tag mb-1"></p-tag>

                        <div *ngIf="isReaction(message)" class="message-text flex align-items-center gap-2">
                            <i class="pi pi-heart text-500"></i>
                            <span>{{ getReactionLabel(message) }}</span>
                        </div>
                        <div class="message-text" *ngIf="!isReaction(message) && hasVisibleBody(message)">{{ message.body_text }}</div>
                        <div *ngIf="isImageAttachment(message)" class="message-image-wrapper mt-2">
                            <a [href]="getAttachmentUrl(message)" target="_blank" rel="noreferrer" class="message-image-link" aria-label="Abrir imagen adjunta en una nueva pestaña">
                                <img [src]="getAttachmentUrl(message) || ''" alt="Imagen adjunta del chat de WhatsApp" class="message-image" />
                            </a>
                        </div>
                        <div *ngIf="!isReaction(message) && !hasVisibleBody(message) && !hasAttachment(message)" class="message-placeholder">Mensaje sin texto visible.</div>

                        <a
                            *ngIf="hasAttachment(message) && !isImageAttachment(message)"
                            [href]="getAttachmentUrl(message)"
                            target="_blank"
                            rel="noreferrer"
                            class="message-link attachment-chip mt-2"
                            aria-label="Abrir archivo adjunto en una nueva pestaña"
                        >
                            <span class="attachment-chip-icon"><i class="pi pi-paperclip"></i></span>
                            <span class="attachment-chip-copy">
                                <span class="attachment-chip-title">{{ getAttachmentLabel(message) }}</span>
                                <small class="attachment-chip-meta">{{ getAttachmentMeta(message) }}</small>
                            </span>
                            <span class="attachment-chip-action">Abrir</span>
                        </a>

                        <div *ngIf="hasProviderError(message)" class="message-error mt-2">
                            {{ message.provider_error_detail }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
